import React from 'react';
import { Typography } from 'components';
import { TableCell } from 'components/table';

const TableCellHeader = ({ title }) => (
  <TableCell>
    <Typography type='bold'>{title}</Typography>
  </TableCell>
);

export default TableCellHeader;
